import { Navigate, Outlet, Link } from "react-router-dom";
import { getRole } from "../DecodeToken/DecodeToken";

const MentorProtectedRoute = () => {
    const role = getRole();
    if (role !== "mentor") {
        return (
            <div style={{ textAlign: "center", marginTop: "3rem" }}>
                <h2 style={{ color: "red", fontSize: "2rem", fontWeight: "bold" }}>
                    You are not authorized to view this page.
                </h2>
                <p style={{ fontSize: "1.2rem", marginBottom: "2rem" }}>
                    This section is for mentors only.
                </p>
                <Link to="/dashboard/home" style={{
                    display: "inline-block",
                    padding: "0.75rem 1.5rem",
                    background: "#e53e3e",
                    color: "#fff",
                    borderRadius: "8px",
                    textDecoration: "none",
                    fontWeight: "bold"
                }}>
                    Go Back Home
                </Link>
            </div>
        );
    }
    return <Outlet />;
};

export default MentorProtectedRoute;